import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import * as actions from '../actions';
import { createBooking, fetchKmPriceApi } from '../config/api';

export default function* BookingSaga() {
  yield takeEvery(actions.createBooking, createBookingRequest);
  yield takeLatest(actions.fetchKmPrice, fetchKmPriceRequest);
}

function* createBookingRequest({ payload: { booking } }) {
  if (booking.startDate && booking.endDate && booking.bus) {
    const result = yield call(createBooking, booking);
    if (result) {
      yield put(actions.createBookingSuccess(result.data));
    }
  } else {
    yield put(actions.createBookingFailure(new Error('Kein Bus gewählt')));
  }
}

function* fetchKmPriceRequest({ payload: { endDateUnix } }) {
  try {
    const result = yield call(fetchKmPriceApi, endDateUnix);
    if (result && result.data) {
      yield put(
        actions.fetchKmPriceSuccess({
          price: result.data.price,
          endDateUnix,
        })
      );
    }
  } catch (error) {
    console.error('Error fetching km price:', error);
    yield put(actions.fetchKmPriceFailure(error));
  }
}
